import React, { Component } from 'react'

export default class Area extends Component {
    render() {
        return (
            <>
                <section className="home2-choose-area pt-100 pb-70 ">
                    <div className="container">
                        <div className="section-title">
                            
                            <h2>We Achieved People’s Trust by Our Great Service</h2>
                          
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-sm-4">
                                <div className="single-choose">
                                    <div className="icon">
                                        <i className="flaticon-friends" />
                                    </div>
                                    <h3>Understanding</h3>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-4">
                                <div className="single-choose">
                                    <div className="icon">
                                        <i className="flaticon-award" />
                                    </div>
                                    <h3>Best Quality</h3>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-4">
                                <div className="single-choose">
                                    <div className="icon">
                                        <i className="flaticon-chip" />
                                    </div>
                                    <h3>Technology</h3>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-4">
                                <div className="single-choose">
                                    <div className="icon">
                                        <i className="flaticon-customer-service" />
                                    </div>
                                    <h3>Support 24/7</h3>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-4">
                                <div className="single-choose">
                                    <div className="icon">
                                        <i className="flaticon-like" />
                                    </div>
                                    <h3>Expert Team</h3>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-4">
                                <div className="single-choose">
                                    <div className="icon">
                                        <i className="flaticon-coin" />
                                    </div>
                                    <h3>Price Oriented</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
